import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import {compose} from 'redux';
import * as Yup from 'yup';
import {
  AppForm,
  AppFormField,
  AppFormSubmitButton,
  ErrorMessage,
} from '../../../components/forms';
import * as fonts from '../../../util/fonts';
import {Column, Row} from '../../../components/layout';
import colors from '../../../util/colors';
import './styles.scss';
import {strings} from '../../../util/strings';
import {post} from '../../../api/api';
import {
  uriMemberDataSubmit,
  uriPostPasswordCheckResult,
} from '../../../api/endpoints';
import Icon from '../../../components/icon';
import {Icons} from '../../../util/icons';
import AppErrorMessage from '../../../components/app-error-message/AppErrorMessage';
import ChangeSuccessModal from './change-success-modal';
import ModalTemplate from '../../../components/modal';
import AppCheckboxInput from '../../../components/input/app-checkbox-input';

const validationSchema = Yup.object().shape({
  accountOwner: Yup.string().required(),
});

const validationSchemaModal = Yup.object().shape({
  password: Yup.string().required(),
});

var IBAN = require('iban');

interface IbanFilterProps {
  iBAN: string;
  updateIban: any;
  accountOwner: string;
  userFilter: any;
  loggedUser: any;
  currentUser: any;
  labels: typeof strings.pt.myData;
  labelsCreateRefund: typeof strings.pt.createRefund;
  labelsIbanRefunds: typeof strings.pt.ibanRefunds;
  messageLabels: typeof strings.pt.messages;
  buStyles: any;
  canSubmit?: any;
  user: any;
  toggleIbanEdition?: boolean;
  bankAccountDataHolder: any;
  selectedBu: any;
  titular: any;
}

function IbanFilter({
  iBAN,
  updateIban,
  accountOwner,
  userFilter,
  loggedUser,
  currentUser,
  labels,
  labelsCreateRefund,
  messageLabels,
  buStyles,
  canSubmit,
  user,
  labelsIbanRefunds,
  toggleIbanEdition,
  selectedBu,
  bankAccountDataHolder,
  titular,
}: IbanFilterProps) {
  const [valid, setValid] = useState(false);
  const [statusMessage, setStatusMessage] = useState<any>(null);
  const [formikContext, setFormikContext] = useState<any>();
  const [submitting, setSubmitting] = useState(false);
  const [hoverErrorIcon, setHoverErrorIcon] = useState({
    iban: false,
    accountOwner: false,
  });
  const [iban, setIban] = useState();
  const [validIban, setValidIban] = useState(false);
  const [validIbanCheckbox, setValidIbanCheckbox] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [wrongPassword, setWrongPassword] = useState(false);
  const [validForm, setValidForm] = useState(false);
  const [editingIban, setEditingIban] = useState(false);
  const [editingName, setEditingName] = useState(false);
  const [justSubmitted, setJustSubmitted] = useState(false);
  const [viewPassword, setViewPassword] = useState(false);
  const [ibanMessage, setIbanMessage] = useState('');

  const featureName = 'EditIban';

  const handlePasswordIconClick = () => {
    setViewPassword(!viewPassword);
  };

  const isTitular =
    bankAccountDataHolder === 'SUBSCRIBER'
      ? titular?.memId === selectedBu?.memId &&
        titular?.buId === selectedBu?.buId
      : true;
  const [validatingPassword, setValidatingPassword] = useState(false);
  const [outOfIbanInput, setOutOfIbanInput] = useState(false);
  const [ibanUndefinedByDefault, setIbanUndefinedByDefault] = useState(false);

  const defineOnMouseFunctions = (
    e: React.MouseEvent,
    fieldNamePar: string
  ) => {
    var elem: HTMLElement = e.target as HTMLElement;
    var icon: HTMLElement = elem.nextSibling as HTMLElement;
    if (icon) {
      icon.onmouseover = function () {
        setHoverErrorIcon({...hoverErrorIcon, [fieldNamePar]: true});
      };
      icon.onmouseout = function () {
        setHoverErrorIcon({...hoverErrorIcon, [fieldNamePar]: false});
      };
    }
  };

  const handlePassword = async (password: any) => {
    const body = {
      password: password,
    };
    try {
      await post(
        uriPostPasswordCheckResult(),
        JSON.stringify(body),
        false,
        featureName
      );
      handleOnHideModal();
      handleSubmit();
      setValidatingPassword(false);
    } catch {
      setWrongPassword(true);
      setValidatingPassword(false);
    }
  };

  const handleOnHideModal = () => {
    setShowModal(false);
    setWrongPassword(false);
  };

  const handleSubmit = async () => {
    setSubmitting(true);

    const body = {
      buId: loggedUser.buId,
      memId: loggedUser.memId,
      grpId: loggedUser.grdId,
      famId: loggedUser.famId,
      grpName: loggedUser.grpName,
      multicode: loggedUser.multicode,
      address: userFilter.addr,
      city: userFilter.city,
      zipCode: userFilter.postalcode,
      phone: userFilter.phone,
      mobilePhone: userFilter.cellPhone,
      email: userFilter.email,
      cardName: userFilter.cardName,
      iban: iban,
      username: currentUser.sub,
    };

    try {
      await post(uriMemberDataSubmit(), JSON.stringify(body)).then(
        (response) => {
          if (response) {
            setStatusMessage(true);
            if (iBAN !== body.iban) updateIban(body.iban); //setIbanStore
          } else {
            setStatusMessage(false);
          }
        }
      );
    } catch (e: any) {
      setStatusMessage(false);
    } finally {
      setSubmitting(false);
    }
  };

  const defineIbanMessage = () => {
    if (labelsIbanRefunds.ibanRefunds_ibanIsEnabled === '1') {
      if (
        labelsIbanRefunds.ibanRefunds_bankAccountDataHolder === 'SUBSCRIBER'
      ) {
        setIbanMessage(
          isTitular
            ? labelsIbanRefunds.ibanRefunds_ibanEnabled_owner
            : labelsIbanRefunds.ibanRefunds_ibanEnabled_not_owner
        );
      } else if (
        labelsIbanRefunds.ibanRefunds_bankAccountDataHolder === 'INDIVIDUAL'
      ) {
        setIbanMessage(labelsIbanRefunds.ibanRefunds_ibanEnabled_owner);
      }
    } else {
      if (
        labelsIbanRefunds.ibanRefunds_bankAccountDataRequiredForRefunds ===
          '1' &&
        !iBAN
      ) {
        if (
          labelsIbanRefunds.ibanRefunds_bankAccountDataHolder === 'SUBSCRIBER'
        ) {
          setIbanMessage(
            isTitular
              ? labelsIbanRefunds.ibanRefunds_ibanDisabled_ibanRequired_owner
              : labelsIbanRefunds.ibanRefunds_ibanDisabled_ibanRequired_not_owner
          );
        } else if (
          labelsIbanRefunds.ibanRefunds_bankAccountDataHolder === 'INDIVIDUAL'
        ) {
          setIbanMessage(
            labelsIbanRefunds.ibanRefunds_ibanDisabled_ibanRequired_owner
          );
        }
      }
    }
  };

  useEffect(() => {
    setIbanUndefinedByDefault(!iban);
    setValidForm(!valid);
    defineIbanMessage();
  }, []);

  return (
    <Column className="iban-filter-container-box">
      <ChangeSuccessModal
        setShowModal={setStatusMessage}
        showModal={statusMessage}
      />
      <AppForm
        className="patient-validation-form-container"
        initialValues={{
          iBAN: iBAN || '',
          accountOwner: accountOwner || '',
        }}
        validationSchema={validationSchema}
        onValidation={(valid: boolean) => setValid(valid)}
        onChange={(val: any) => {
          val.iBAN = val.iBAN.replace(' ', '');
          setIban(val.iBAN);
          setValidIban(IBAN.isValid(iban));
        }}
        onSubmit={async (values) => {
          setEditingIban(false);
          setEditingName(false);
          setJustSubmitted(true);
          setShowModal(true);
        }}>
        <Row
          className="iban-data-title"
          style={{...fonts.M, ...fonts.SemiBold}}>
          {labels?.myData_iBANTitle}
        </Row>
        {!canSubmit &&
          !isTitular &&
          !ibanMessage &&
          labelsIbanRefunds.ibanRefunds_ibanIsEnabled === '1' && (
            <Row
              className="iban-data-title"
              style={{...fonts.SM, ...fonts.SemiBold}}>
              {iBAN
                ? labels?.myData_cantSubmit_iBANEnd
                : labelsCreateRefund.refund_alert_not_owner}
            </Row>
          )}
        {ibanMessage && (
          <Row
            className="iban-data-title"
            style={{...fonts.SM, ...fonts.SemiBold}}>
            {ibanMessage}
          </Row>
        )}

        <Column
          className="reimbursement-history-container reimbursement-history-bgbox"
          style={{
            background: 'linear-gradient(180deg, #F9F9F9 0%, #F0F0F0 100%)',
          }}>
          <Row
            className="my-data-iban-top-row"
            style={!canSubmit ? {justifyContent: 'center'} : {}}>
            <Column className="my-data-iban-column">
              <Row className="iban-data-row-title">
                <p className="m-0" style={{...fonts.SM}}>
                  {labels?.myData_iBAN}
                </p>
              </Row>
              <Row
                className="iban-data-row iban-data-row-edit iban-data-row-checkbox"
                style={{position: 'relative'}}>
                <AppFormField
                  className="profile-input"
                  name="iBAN"
                  handleFormikContext={(formik) => {
                    if (
                      !!!formikContext ||
                      formik.errors !== (formikContext as any).errors
                    ) {
                      setFormikContext(formik);
                    }
                  }}
                  onMouseOver={(e) => defineOnMouseFunctions(e, 'iban')}
                  error={
                    !IBAN.isValid(iban) && outOfIbanInput
                      ? 'iban Invalido'
                      : undefined
                  } //o valor é irrelevante, apenas interessa ter alguma string não undefined para o icone aparecer.
                  disabled={
                    !canSubmit ||
                    (!editingIban && IBAN.isValid(iban)) ||
                    ibanUndefinedByDefault
                  }
                  onClick={() => {
                    setOutOfIbanInput(false);
                    canSubmit && !IBAN.isValid(iban) && setEditingIban(true);
                  }}
                  onBlur={() => setOutOfIbanInput(true)}
                />
                {formikContext && canSubmit && (
                  <>
                    <Icon
                      className="profile-input-icon"
                      name={Icons.PENCIL}
                      width="20"
                      height="20"
                      changeViewbox
                      viewBox={'0 0 24 24'}
                      color={buStyles?.primaryColor || colors.blue}
                      onClick={() => {
                        justSubmitted && setJustSubmitted(false);
                        setEditingIban(!editingIban);
                        setIbanUndefinedByDefault(false);
                      }}
                    />
                  </>
                )}
                {((formikContext && !!formikContext?.errors.iBAN) ||
                  !IBAN.isValid(iban)) &&
                  hoverErrorIcon.iban &&
                  outOfIbanInput && (
                    <AppErrorMessage
                      className="iban-error-message"
                      message={messageLabels.invalidIBAN}
                    />
                  )}
              </Row>
            </Column>
            <Column className="my-data-iban-column my-data-iban-checkbox">
              {editingIban && (
                <Row className="iban-data-row" style={{marginBlock: 'auto'}}>
                  <AppCheckboxInput
                    style={{alignItems: 'center', fontSize: '14px'}}
                    className="iban-data-checkbox"
                    checked={validIbanCheckbox}
                    onChange={(value: boolean) => {
                      setValidIbanCheckbox(value);
                    }}
                    label={labels.myData_iBANCheckboxText}
                  />
                </Row>
              )}
            </Column>
            {canSubmit && (
              <Row
                className="my-data-iban-bottom-row-mobile"
                style={{...fonts.SM}}>
                {labels?.myData_iBANEnd}
              </Row>
            )}
            {canSubmit && (
              <Column className="iban-data-save-column">
                <Row style={{justifyContent: 'center'}}>
                  <AppFormSubmitButton
                    title={labels?.myData_iBANSave}
                    className="stepper-continue-button"
                    variant="inverted"
                    disabled={
                      !valid ||
                      submitting ||
                      !validIban ||
                      justSubmitted ||
                      !validIbanCheckbox
                    }
                  />
                </Row>
              </Column>
            )}
          </Row>
          {canSubmit && (
            <Row
              className="my-data-iban-bottom-row-desktop"
              style={{...fonts.SM}}>
              <p>{labels?.myData_iBANEnd}</p>
            </Row>
          )}
        </Column>
      </AppForm>
      <ModalTemplate
        show={showModal}
        onHide={handleOnHideModal}
        cross={true}
        hideFooter={true}>
        <AppForm
          className="patient-validation-form-container"
          initialValues={{
            password: '',
          }}
          validationSchema={validationSchemaModal}
          onSubmit={(values) => {
            setValidatingPassword(true);
            handlePassword(values.password);
          }}
          onValidation={(valid: boolean) => {
            if (validForm !== valid) {
              setValidForm(valid);
            }
          }}>
          <Row style={{...fonts.M, fontWeight: 'bold'}}>
            {labels?.myData_iBANReimbursement}
          </Row>
          <Row style={{...fonts.M}}>
            {`${labels?.myData_passwordCheck1} ${user.given_name}${labels?.myData_passwordCheck2}`}
          </Row>
          <Row className="account-data-row">
            <AppFormField
              type={viewPassword ? '' : 'password'}
              passwordIcon={true}
              pwdIconClass="pwd-eye-icon"
              handlePasswordIconClick={() => handlePasswordIconClick()}
              showPassword={viewPassword}
              name="password"
              placeholder="Palavra-passe"
            />
          </Row>
          <ErrorMessage
            error={labels?.myData_password_error}
            visible={wrongPassword}
          />
          <Row className="patient-validation-continue-button-row">
            <AppFormSubmitButton
              title={labelsCreateRefund.createRefund_confirm}
              className="stepper-continue-button"
              disabled={!validForm || validatingPassword}
            />
          </Row>
        </AppForm>
      </ModalTemplate>
    </Column>
  );
}

const mapStateToProps = ({
  strings,
  globalStyles,
  user,
  bankAccountDataHolder,
  selectedBu,
  titular,
}: any) => ({
  labels: strings.value.pt.myData,
  labelsCreateRefund: strings.value.pt.createRefund,
  labelsIbanRefunds: strings.value.pt.ibanRefunds,
  buStyles: globalStyles.value,
  messageLabels: strings.value.pt.messages,
  user: user.value,
  bankAccountDataHolder: bankAccountDataHolder.value,
  selectedBu: selectedBu.value,
  titular: titular.value,
});

export default compose(connect(mapStateToProps)(IbanFilter));
